(() => {
  const ready = (fn) => {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn, { once: true });
    } else {
      fn();
    }
  };

  const RAW_TO_KEY = {
    "This field is required.": "required",
    "Your message has been sent.": "success",
    "The given data was invalid.": "invalid",
    "Thanks for getting in touch! We appreciate you contacting us. One of our colleagues will get back in touch with you soon!":
      "thanks",
  };

  function initSection({ sectionId, translations }) {
    const root = document.querySelector(`.section-${CSS.escape(sectionId)}`);
    if (!root) return;

    // -----------------------------
    // 1) Sync "Modell" input with active swiper slide
    // -----------------------------
    const modellInput = root.querySelector("input#modell.coming-soon-form_modell");
    const swiperContainer = root.querySelector(".swiper-container"); // adjust if your swiper attaches elsewhere

    if (modellInput && swiperContainer) {
      const setModelFromActiveSlide = (swiper) => {
        const slide = swiper.slides?.[swiper.activeIndex];
        const titleEl = slide?.querySelector(".card__heading");
        const name = titleEl?.textContent?.trim();
        if (name) modellInput.value = name;
      };

      const waitForSwiper = (tries = 0) => {
        const swiper = swiperContainer.swiper;
        if (swiper) {
          setModelFromActiveSlide(swiper);
          swiper.on("slideChange", () => setModelFromActiveSlide(swiper));
          swiper.on("transitionEnd", () => setModelFromActiveSlide(swiper));
          return;
        }
        if (tries > 180) return; // give it a bit longer than before
        requestAnimationFrame(() => waitForSwiper(tries + 1));
      };

      waitForSwiper();
    }

    // -----------------------------
    // 2) Translate inserted validation/success messages
    // -----------------------------
    const selector =
      ".help-block, .form-success, .form-message, .alert-error, .alert-success";

    const translateMessages = () => {
      const nodes = root.querySelectorAll(selector); // scope to this section
      nodes.forEach((el) => {
        const raw = (el.textContent || "").trim();
        const key = RAW_TO_KEY[raw];
        if (!key) return;

        const translated = translations?.[key];
        if (!translated) return;

        el.textContent = translated;
      });
    };

    translateMessages();

    const translateObs = new MutationObserver(() => translateMessages());
    translateObs.observe(root, { childList: true, subtree: true });

    // -----------------------------
    // 3) Move success/error messages into datenschutz area
    // -----------------------------
    const moveAlerts = () => {
      const datenschutzWrapper = root.querySelector(".coming-soon-form-datenschutzOuterCS");
      if (!datenschutzWrapper) return;

      const successEls = root.querySelectorAll(".alert.alert-success, .alert-success");
      successEls.forEach((successEl) => {
        if (!datenschutzWrapper.contains(successEl)) {
          datenschutzWrapper.appendChild(successEl);
        }
        const p = datenschutzWrapper.querySelector(".coming-soon-form-datenschutz");
        if (p) p.style.display = "none";
        datenschutzWrapper.dataset.successReplaced = "1";
      });

      const errorEls = root.querySelectorAll(".alert.alert-error, .alert-error");
      errorEls.forEach((errorEl) => {
        if (!datenschutzWrapper.contains(errorEl)) {
          datenschutzWrapper.appendChild(errorEl);
        }
      });
    };

    moveAlerts();

    const alertObs = new MutationObserver(() => moveAlerts());
    alertObs.observe(root, { childList: true, subtree: true });
  }

  ready(() => {
    const list = window.comingSoonConfig || [];
    list.forEach(initSection);

    // Optional: if sections are loaded later (theme editor, ajax),
    // you can re-run init when config gets pushed.
    const originalPush = list.push.bind(list);
    list.push = (...items) => {
      const res = originalPush(...items);
      items.forEach(initSection);
      return res;
    };
  });
})();

 document.addEventListener('DOMContentLoaded', function () {
    var inputs = document.querySelectorAll('input.coming-soon-form_email');
    if (!inputs.length) return;

    inputs.forEach(function (input) {
      function updateHasValue() {
        if (input.value && input.value.trim() !== '') {
          input.classList.add('has-value');
        } else {
          input.classList.remove('has-value');
        }
      }

      // on page load (important for autofill / redirects)
      updateHasValue();

      // on user interaction
      input.addEventListener('input', updateHasValue);
      input.addEventListener('change', updateHasValue);

      var form = input.closest('form');
      if (form) {
        var datenschutzWrapper = form.querySelector('.coming-soon-form-datenschutzOuterCS');
        var shouldClearForSuccess = function () {
          if (datenschutzWrapper && datenschutzWrapper.dataset.successReplaced === '1') {
            return true;
          }
          return (
            form.querySelector('.alert.alert-success, .alert-success, .form-success, .form-message.success') !== null
          );
        };
        var removeHasValueAfterSubmit = function () {
          window.setTimeout(function () {
            if (shouldClearForSuccess()) {
              input.classList.remove('has-value');
              return;
            }
            if (input.value && input.value.trim() !== '') {
              input.classList.add('has-value');
            }
          }, 0);
        };

        form.addEventListener('submit', removeHasValueAfterSubmit);

        var submitButton = form.querySelector('button[type="submit"]');
        if (submitButton) {
          submitButton.addEventListener('click', removeHasValueAfterSubmit);
        }

        var successObserver = new MutationObserver(function () {
          if (shouldClearForSuccess()) {
            input.classList.remove('has-value');
          }
        });
        successObserver.observe(form, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['data-success-replaced'],
        });
      }
    });
  });
